export default __webpack_public_path__ + "static/media/Group2841.9a7bd9e1.svg";